import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { NODE_TYPE_OPERAND, OPERAND_TYPE_FUNCTION } from '../constants';
import { assignParent } from './common';
function acceptFunctionOperand(visitor) {
  return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
}
function enterNode(listener) {
  listener.enterFunctionOperand && listener.enterFunctionOperand(this);
}
function exitNode(listener) {
  listener.exitFunctionOperand && listener.exitFunctionOperand(this);
}
function getChildren() {
  return [this.function].concat(_toConsumableArray(this.arguments));
}
export var functionOperand = function functionOperand(functionString) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return functionOperandInternal(functionString, args);
};
export var functionOperandInternal = function functionOperandInternal(functionString, args) {
  var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var node = {
    type: NODE_TYPE_OPERAND,
    operandType: OPERAND_TYPE_FUNCTION,
    function: functionString,
    arguments: args,
    position: position,
    accept: acceptFunctionOperand,
    enterNode: enterNode,
    exitNode: exitNode,
    getChildren: getChildren,
    parent: null
  };
  assignParent(node);
  return node;
};